import React from 'react';
import { createStyles, SegmentedControl } from '@mantine/core';

const useStyles = createStyles((theme) => ({
    root: {
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.white,
        boxShadow: theme.shadows.md,
        border: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[1]
        }`,
    },
    active: {
        backgroundColor: theme.colors.red,
    },
    control: {
        border: '0 !important',
    },
    labelActive: {
        color: `${theme.white} !important`,
    },
}));

export function HeaderSubSectionSelect() {
  const { classes } = useStyles();
  return (
    <SegmentedControl
      radius="xl"
      size="md"
      data={['All', 'Local', 'Deals',]}
      classNames={classes}
    />
  );
}
